import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConsulteGrid, {
      columns: _ctx.rows,
      "data-source": _ctx.dataSource,
      actions: true,
      onOnChangeDataRow: _ctx.rowChange
    }, {
      header: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: {
        name: 'pattipobem_create',
        params: { patGrupoId: _ctx.patGrupoId }
      },
          class: "btn btn-primary rounded-pill",
          style: {"margin-left":"10px"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "uil uil-plus",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Cadastrar ", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      botaoSelecionar: _withCtx((context) => [
        _createElementVNode("button", {
          class: "btn btn-outline-warning",
          onClick: ($event: any) => (_ctx.selecionarRegistro(context.row)),
          type: "button"
        }, " Editar ", 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "onOnChangeDataRow"])
  ]))
}